import reportError from 'ha/helpers/bugsnag/reportError';
import { updateSearchParams, setPreviousParams } from './actions';
import loadSearchResults from './loadSearchResults';
import loadUniversities from './loadUniversities';
import loadCitiesNearby from './loadCitiesNearby';
import saveSearch from './saveSearch';

import { getSearchParams, shouldUseMapBounds, getBounds } from '../selectors';

export default (reqParams = {}) =>
  (dispatch, getState) => {
    dispatch(updateSearchParams(reqParams));

    const state = getState();
    const searchParams = getSearchParams(state);
    const useMapBounds = shouldUseMapBounds(state);
    const mapBounds = getBounds(state);

    const searchParamsWithMapBounds = {
      ...searchParams,
      ...(useMapBounds && {
        ...mapBounds,
      }),
    };

    /*
    We call loadSearchResults -/geonames/search-city separately,
    because we call external geocoder first to get a geo data and put it to the cache after,
    so the following calls:
      loadUniversities - /pois
      loadCitiesNearby - /geonames/cities
    will get data from our cache and that will reduce a load on external API
  */
    return dispatch(
      loadSearchResults(searchParamsWithMapBounds, {
        localizedKind: reqParams.localizedKind,
        priceAverage: reqParams.priceAverage,
      }),
    )
      .then(() =>
        Promise.all([
          dispatch(loadUniversities(searchParamsWithMapBounds)),
          dispatch(loadCitiesNearby(searchParamsWithMapBounds)),
        ]),
      )
      .then(() => {
        dispatch(saveSearch());
        dispatch(setPreviousParams(searchParamsWithMapBounds));
      })
      .catch(reportError);
  };
